import { createContext, FC, ReactNode, useContext, useState } from 'react';
import { useStore } from 'zustand';

import {
  createPrescriptionSettingStore,
  PrescriptionSettingState,
  PrescriptionSettingStoreApi,
  selectAllDays,
  selectCanAddSchedule,
  selectHasSchedule,
  selectStimulationSetting,
  selectStimulationSettingFormValue,
} from '../stores/createPrescriptionSettingStore';

export const PrescriptionSettingStoreContext = createContext<PrescriptionSettingStoreApi | null>(null);

export function usePrescriptionSettingStore<U>(selector: (s: PrescriptionSettingState) => U): U {
  const api = useContext(PrescriptionSettingStoreContext);
  if (!api) {
    throw new Error('usePrescriptionSettingStore must be used within PrescriptionSettingProvider');
  }
  return useStore(api, selector);
}

export {
  selectAllDays,
  selectCanAddSchedule,
  selectHasSchedule,
  selectStimulationSetting,
  selectStimulationSettingFormValue,
};

export const PrescriptionSettingProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [store] = useState(() => createPrescriptionSettingStore());

  return (
    <PrescriptionSettingStoreContext.Provider value={store}>
      {children}
    </PrescriptionSettingStoreContext.Provider>
  );
};
